<div *ngIf="!showRequest" class="">
        <h2 *ngIf="!IsAdminMode" class="sectionTitle">
            {{'FRONT_USER.REGISTRATION_FORM.REGISTRATION' | translate }}</h2>

        <div *ngIf="baseRequestDTO">
            <!--request Details summary-->
            <app-request-details [baseRequest]="baseRequestDTO"></app-request-details>
        </div>


        <div
            *ngIf="(!loggedInUser?.IsAdmin && formMode!=FormMode.Add && requestStatus == ServiceStatus.MoreInformationRequestedFromAgent) || isCompleted ">
            <div class="form-container">
                <h4 class="section-title">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.REQUIRED_INFORMATION'| translate}}</h4>
                <div class="form-group">
                    <label
                        for="UserMoreInformation">{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MORE_INFORMATION' | translate}}</label>
                    <textarea [(ngModel)]="getAgentInfo.MoreInformation" id="UserMoreInformation" name="UserMoreInformation"
                        disabled class="form-control"></textarea>
                </div>
            </div>
        </div>



        <form [formGroup]="registerForm" #register (ngSubmit)="onSubmit()">
            <div>
                <div class="form-container">
                    <div class="form-section">
                        <h4 class="section-title">{{'FRONT_USER.REGISTRATION_FORM.BASIC_INFO'| translate}}</h4>

                        <div class="form-group">
                            <label for="username">{{ 'FRONT_USER.REGISTRATION_FORM.USER_NAME' | translate}}</label>
                            <span class="red"> *</span>
                            <input type="text" formControlName="username" (change)="onChangeUserName($event)" id="username"
                                name="username" class="form-control" (keydown.space)="$event.preventDefault();"
                                [ngClass]="{ 'is-invalid': submitted ||( f.username?.dirty && f.username?.errors) }" />
                            <div *ngIf="formMode==FormMode.Add" class="blue italic">
                                <span>
                                    {{'FRONT_USER.REGISTRATION_FORM.USERNAME_EMAIL_ERROR' | translate}}
                                </span>
                            </div>
                            <div *ngIf="submitted ||( f.username?.dirty && f.username?.errors)" class="red ">
                                <div *ngIf="f.username?.errors?.required">
                                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                </div>
                                <div *ngIf="f.username?.errors?.pattern">
                                    {{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_REPRESENTATIVE_FORM.NAME_EMAIL_ERROR' | translate}}
                                </div>
                                <div *ngIf="f.username?.errors?.startsWithSpaceError">
                                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                                </div>
                            </div>
                            <div *ngIf="userNameError.isError" class="red">
                                {{ userNameError.errorMessage }}
                            </div>
                        </div>

                        <div class="form-group" *ngIf="formMode==FormMode.Add">
                            <label for="password">{{'FRONT_USER.REGISTRATION_FORM.PASSWORD'| translate}}</label>
                            <span class="red"> *</span>
                            <input type="password" formControlName="password" id="password" name="password"
                                class="form-control"
                                [ngClass]="{ 'is-invalid': submitted ||( f.password?.dirty && f.password?.errors) }" />
                            <div *ngIf="submitted || (f.password?.dirty && f.password?.errors)" class="red">
                                <div *ngIf="f.password?.errors?.required">
                                    {{'FRONT_USER.This_Field_Is_Required'| translate}}
                                </div>
                                <!-- <div *ngIf="f.password?.errors?.minlength">
                                    {{'FRONT_USER.REGISTRATION_FORM.PASSWORD_LENGTH_ERROR'| translate}}
                                </div> -->
                                <div *ngIf="f.password?.errors?.passwordStrength">
                                    {{'FRONT_USER.PASSWORD_ERROR'| translate}}
                                </div>


                            </div>
                        </div>

                        <div class="form-group" *ngIf="formMode==FormMode.Add">
                            <label
                                for="confirmpassword">{{'FRONT_USER.REGISTRATION_FORM.CONFIRM_PASSWORD'| translate}}</label>
                            <span class="red"> *</span>
                            <input type="password" formControlName="confirmpassword" id="confirmpassword"
                                name="confirmpassword" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted || (f.confirmpassword?.dirty&& f.confirmpassword?.errors) }" />
                            <div *ngIf="submitted || (f.confirmpassword?.dirty && f.confirmpassword?.errors)" class="red ">
                                <div *ngIf="f.confirmpassword?.errors?.required">
                                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                </div>
                                <div *ngIf="f.confirmpassword?.errors?.mustMatch">
                                    {{'FRONT_USER.REGISTRATION_FORM.CONFIRM_PASSWORD_ERROR' | translate}}
                                </div>

                            </div>
                        </div>

                        <div class="form-group">
                            <label
                                for="registrationType">{{'FRONT_USER.REGISTRATION_FORM.REGISTRATION_TYPE'| translate}}</label>
                            <span class="red"> *</span>
                            <select formControlName="registrationType" id="registrationType" name="registrationType"
                                class="form-control" (change)="clearForm($event)"
                                [ngClass]="{ 'is-invalid': submitted || (f.registrationType?.dirty && f.registrationType?.errors) }">
                                <option [value]='null' selected>
                                    {{'FRONT_USER.REGISTRATION_FORM.REGISTRATION_TYPE_CHOOSE' | translate}}
                                </option>
                                <ng-container *ngFor="let type of registrationTypes">
                                    <option *ngIf="displayedLang==Languages.English" [value]="type.Id">
                                        {{type.NameEN}}
                                    </option>
                                    <option *ngIf="displayedLang==Languages.Arabic" [value]="type.Id">
                                        {{type.NameAR}}
                                    </option>
                                </ng-container>
                            </select>
                            <div *ngIf="submitted || (f.registrationType?.dirty && (f.registrationType?.errors || f.registrationType?.value=='null') )"
                                class="red ">
                                <div *ngIf="f.registrationType?.errors?.required  || f.registrationType?.value=='null' ">
                                    {{'FRONT_USER.This_Field_Is_Required'| translate}}
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="bs-callout bs-callout-info mrg-top-0"
                        *ngIf="formMode==FormMode.Add && user.RegisterTypeId==RegisterType.PortalUser">

                        <h4>{{'FRONT_USER.REGISTRATION_FORM.PORTAL_USER' | translate}}</h4>
                        <label>{{'FRONT_USER.REGISTRATION_FORM.PORTAL_INFO_SERVICE'| translate}}</label>
                        <ul>
                            <li>{{'FRONT_USER.SERVICES.LONG_HAUL_SERVICES' | translate }}</li>
                            <li>{{'FRONT_USER.SERVICES.SHIPYARD_SERVICES' | translate }}</li>
                        </ul>
                        <label>{{'FRONT_USER.REGISTRATION_FORM.PORTAL_DOCS' | translate}}</label>
                        <ul>
                            <li>{{'FRONT_USER.REGISTRATION_FORM.PORTAL_NO_DOCS' | translate}}</li>
                        </ul>
                    </div>

                    <div class="form-section" *ngIf="user.RegisterTypeId==RegisterType.PortalUser">
                        <h4 class="section-title">{{'FRONT_USER.REGISTRATION_FORM.PORTAL_USER' | translate}}</h4>
                        <div class="form-group">
                            <label for="userType">{{'FRONT_USER.REGISTRATION_FORM.USER_TYPE' | translate}}</label>
                            <span class="red"> *</span>
                            <select formControlName="userType" id="userType" name="userType" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted ||(f.userType?.dirty && f.userType?.errors) }">
                                <option [value]='null' selected>
                                    {{'FRONT_USER.REGISTRATION_FORM.USER_TYPE_CHOOSE' | translate}}
                                </option>
                                <ng-container *ngFor="let userType of portalUserTypes">
                                    <option *ngIf="displayedLang==Languages.English" [value]="userType.Id">
                                        {{userType.NameEN}}
                                    </option>
                                    <option *ngIf="displayedLang==Languages.Arabic" [value]="userType.Id">
                                        {{userType.NameAR}}
                                    </option>
                                </ng-container>

                            </select>
                            <div *ngIf="submitted ||(f.userType?.dirty && (f.userType?.errors || f.userType?.value=='null') )"
                                class="red">
                                <div *ngIf="f.userType?.errors?.required || f.userType?.value=='null' ">
                                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                </div>
                            </div>
                        </div>
                        <!--preferred service id-->
                        <div class="form-group">
                            <label
                                for="PreferedServiceId">{{'FRONT_USER.REGISTRATION_FORM.PREFEERD_TYPE' | translate}}</label>
                            <span class="red"> *</span>
                            <select formControlName="PreferedServiceId" id="PreferedServiceId" name="PreferedServiceId"
                                class="form-control"
                                [ngClass]="{ 'is-invalid': submitted ||(f.PreferedServiceId?.dirty && f.PreferedServiceId?.errors) }">
                                <option [value]='null' selected>
                                    {{'FRONT_USER.REGISTRATION_FORM.USER_PREFERRED_TYPE_CHOOSE' | translate}}
                                </option>
                                <ng-container *ngFor="let service of preferredServices">
                                    <option *ngIf="displayedLang==Languages.English" [value]="service.Id">
                                        {{service.NameEN}}
                                    </option>
                                    <option *ngIf="displayedLang==Languages.Arabic" [value]="service.Id">
                                        {{service.NameAR}}
                                    </option>
                                </ng-container>

                            </select>
                            <div *ngIf="submitted ||(f.PreferedServiceId?.dirty && (f.PreferedServiceId?.errors || f.PreferedServiceId?.value=='null') )"
                                class="red">
                                <div *ngIf="f.PreferedServiceId?.errors?.required || f.PreferedServiceId?.value=='null' ">
                                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="fullName">{{'FRONT_USER.REGISTRATION_FORM.FULL_NAME' | translate}}</label>
                            <span class="red"> *</span>
                            <input type="text" formControlName="fullName" id="fullName" name="fullName" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted ||( f.fullName?.dirty && f.fullName?.errors) }" />
                            <div *ngIf="submitted ||( f.fullName?.dirty  && f.fullName?.errors)" class="red ">
                                <div *ngIf="f.fullName?.errors?.required">
                                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                </div>
                                <div *ngIf="f.fullName?.errors?.startsWithSpaceError">
                                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                                </div>
                            </div>

                        </div>

                        <div class="form-group">
                            <label for="country">{{'FRONT_USER.REGISTRATION_FORM.COUNTRY' | translate}}</label>
                            <span class="red"> *</span>
                            <select formControlName="country" id="country" name="country" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted ||( f.country?.dirty  && f.country?.errors) }">
                                <option [value]='null' selected>
                                    {{'FRONT_USER.REGISTRATION_FORM.COUNTRY_CHOOSE' |translate}}
                                </option>
                                <ng-container *ngFor="let count of Countries">
                                    <option *ngIf="displayedLang==Languages.English" [value]="count.Id">
                                        {{count.NameEN}}
                                    </option>
                                    <option *ngIf="displayedLang==Languages.Arabic" [value]="count.Id">
                                        {{count.NameAR}}
                                    </option>
                                </ng-container>



                            </select>
                            <div *ngIf="submitted || ( f.country?.dirty && (f.country?.errors || f.country?.value=='null'))"
                                class="red ">
                                <div *ngIf="f.country?.errors?.required || f.country?.value=='null' ">
                                    {{'FRONT_USER.This_Field_Is_Required' |translate}}
                                </div>
                            </div>
                        </div>

                       <!-- <div class="form-group">
                            <label for="mobile">{{'FRONT_USER.REGISTRATION_FORM.MOBILE' |translate}}</label>
                            <span class="red"> *</span>
                            <ngx-intl-tel-input [enableAutoCountrySelect]="true" [enablePlaceholder]="true" id="mobile"
                                name="mobile" formControlName="mobile" cssClass="form-control"></ngx-intl-tel-input>
                            <div *ngIf="submitted ||( f.mobile?.touched && f.mobile?.dirty  && f.mobile?.errors)"
                                class="red">
                                <div *ngIf="f.mobile?.errors?.required">
                                    {{'FRONT_USER.This_Field_Is_Required' |translate}}
                                </div>
                            </div>
                            <div class="red"
                                *ngIf="f.mobile?.touched &&f.mobile?.dirty && f.mobile?.errors?.validatePhoneNumber">
                                {{'FRONT_USER.REGISTRATION_FORM.VALID_PHONE_NUMBER' | translate}}
                            </div>
                        </div>-->
                        <div class="form-group">
                          <label for="mobile">{{ 'FRONT_USER.REGISTRATION_FORM.MOBILE' | translate}}</label>
                          <span class="red"> *</span>
                          <input type="text" formControlName="mobile" name="mobile" class="form-control" />
                          <div *ngIf="submitted ||( f.mobile?.touched && f.mobile?.dirty  && f.mobile?.errors)"
                          class="red">
                          <div *ngIf="f.mobile?.errors?.required">
                              {{'FRONT_USER.This_Field_Is_Required' |translate}}
                          </div>
                          </div>
                          <div class="red"
                              *ngIf="f.mobile?.touched &&f.mobile?.dirty && f.mobile?.errors?.validatePhoneNumber">
                              {{'FRONT_USER.REGISTRATION_FORM.VALID_PHONE_NUMBER' | translate}}
                          </div>
                        </div>

                        <div class="form-group">
                            <label for="fax">{{ 'FRONT_USER.REGISTRATION_FORM.FAX' | translate}}</label>
                            <input type="text" formControlName="fax" class="form-control" />
                            <div *ngIf="submitted ||(f.fax?.dirty &&f.fax?.errors)" class="red ">
                                <div *ngIf="f.fax?.errors?.pattern">
                                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="organization">{{ 'FRONT_USER.REGISTRATION_FORM.ORGANIZATION' | translate}}</label>
                            <input type="text" formControlName="organization" id="organization" name="organization"
                                class="form-control" />
                        </div>
                        <div class="form-group">
                            <label for="address">{{'FRONT_USER.REGISTRATION_FORM.ADDRESS' | translate}}</label>
                            <textarea formControlName="address" id="address" name="address"
                                class="form-control"> </textarea>
                        </div>

                    </div>
                </div>
                <div *ngIf="user.RegisterTypeId==RegisterType.Agent">
                    <div *ngIf="formMode==FormMode.Add" class="bs-callout bs-callout-info mrg-top-0">
                        <h4>{{'FRONT_USER.REGISTRATION_FORM.AGENT'| translate}}</h4>
                        <label>{{'FRONT_USER.REGISTRATION_FORM.AGENT_INFO_SERVICE'| translate}}</label>
                        <ul>
                            <li>{{'FRONT_USER.SERVICES.E_BOOKING_SERVICES' | translate }}</li>
                            <li>{{'FRONT_USER.SERVICES.LONG_HAUL_SERVICES' | translate }}</li>
                            <li>{{'FRONT_USER.SERVICES.SHIPYARD_SERVICES' | translate }}</li>
                        </ul>
                        <label>{{'FRONT_USER.REGISTRATION_FORM.PORTAL_DOCS' | translate}}</label>
                        <ul>
                            <li>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.SHIPPING_LICENSING'|translate}}
                            </li>
                            <li>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.TAX_CARD'|translate}}</li>
                            <li>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.TAX_AUTHORIZATION'|translate}}
                            </li>
                            <li>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.COMMERCIAL_RECORD'|translate}}
                            </li>
                        </ul>
                    </div>
                    <agent-form #agentChild class="block" (updatedAgentEvent)="receiveUpdatedAgent($event)"
                        (isTabOneValid)="receiveTabOne($event)" [RequestStatus]="requestStatus"
                        (agentEvent)="receiveAgent($event)" [formSubmitted]="submitted"
                        (getRepresentativeUserName)="receiveRepresentative($event)" (isTabTwoValid)="receiveTabTwo($event)"
                        formControlName="agent">
                    </agent-form>
                </div>
                <div #divSupplierChild *ngIf="user.RegisterTypeId==RegisterType.Supplier">
                    <div *ngIf="formMode==FormMode.Add" class="bs-callout bs-callout-info mrg-top-0">
                        <h4>{{'FRONT_USER.REGISTRATION_FORM.SUPPLIER' | translate}}</h4>
                        <label>{{'FRONT_USER.REGISTRATION_FORM.SUPPLIER_INFO_SERVICE'| translate}}</label>
                        <ul>
                            <li>{{'FRONT_USER.SERVICES.ETendersServices' | translate }}</li>
                        </ul>
                        <label>{{'FRONT_USER.REGISTRATION_FORM.PORTAL_DOCS' | translate}}</label>
                        <ul>
                            <li>{{'FRONT_USER.REGISTRATION_FORM.Supplier_TaxCard' | translate}}</li>
                            <li>{{'FRONT_USER.REGISTRATION_FORM.Supplier_VATRegistration' | translate}}</li>
                            <li>{{'FRONT_USER.REGISTRATION_FORM.Supplier_CommercialRecord' | translate}}</li>
                            <li>{{'FRONT_USER.REGISTRATION_FORM.Supplier_LastTwoYearsBalanceSheet' | translate}}</li>
                        </ul>
                    </div>
                    <supplier-registration-form #supplierChild formControlName="supplier" class="block"
                        [formSubmitted]="submitted" [RequestStatus]="requestStatus"
                        [IsSupplierRegistrationType]="isSupplierRegistrationType"
                        (isLocalSupplier)="receiveIsLocalSupplier($event)"
                        (updatedSupplierEvent)="receiveUpdatedSupplier($event)" (supplierEvent)="receiveSupplier($event)"
                        (isSupplierFormValid)="receiveIsSupplierFormValid($event)">
                    </supplier-registration-form>
                </div>
                <div *ngIf="(formMode==FormMode.Add && user.RegisterTypeId==RegisterType.PortalUser ) ||
                (formMode==FormMode.Add && user.RegisterTypeId==RegisterType.Agent && validateSubmitButton) ||
                (formMode==FormMode.Add && user.RegisterTypeId==RegisterType.Supplier && isLocalSupplier && isSupplierFormValid)" class="form-container">

                        <h4 class="section-title">{{ 'FRONT_USER.REGISTRATION_FORM.CAPTCHA' | translate}}</h4>

                        <div class="form-group">
                            <label for="recaptcha">{{ 'FRONT_USER.REGISTRATION_FORM.CAPTCHA' | translate}}</label>
                            <span class="red"> *</span>

                            <ngx-recaptcha2 #captchaElem [siteKey]="sitekey" [useGlobalDomain]="false"
                                formControlName="recaptcha" [hl]="lang">
                            </ngx-recaptcha2>
                            <div *ngIf="submitted ||( f.recaptcha?.dirty  && f.recaptcha?.errors)" class="red ">
                                <div *ngIf="f.recaptcha?.errors?.required">
                                    {{ 'FRONT_USER.This_Field_Is_Required' | translate}}
                                </div>
                            </div>
                        </div>
                </div>

                <div *ngIf="(formMode==FormMode.Add && user.RegisterTypeId==RegisterType.PortalUser ) ||
                (formMode==FormMode.Add &&user.RegisterTypeId==RegisterType.Agent && validateSubmitButton) ||
                (formMode==FormMode.Add && user.RegisterTypeId==RegisterType.Supplier && isLocalSupplier && isSupplierFormValid)" class="form-container">
                    <h4  class="section-title">{{ 'FRONT_USER.TERMS_CONDITIONS'  | translate}}</h4>
                    <div  class="form-group">
                        <label for="TermsAndConditions">{{ 'FRONT_USER.TERMS_CONDITIONS' | translate }}</label>
                        <span class="red"> *</span>

                        <div class="form-custom-inputs">
                            <div class="custom-checkbox">
                                <input type="checkbox" id="TermsAndConditions" name="TermsAndConditions"
                                    formControlName="TermsAndConditions" />
                                <label for="TermsAndConditions">
                                    <a (click)="goToTermsAndCond()" target="_blank">
                                        {{ 'FRONT_USER.TERMS_CONDITIONS_Acceptence' | translate }}
                                    </a>
                                </label>

                            </div>
                        </div>
                        <div *ngIf="submitted ||(f.TermsAndConditions.dirty && f.TermsAndConditions?.errors)" class="red ">
                            <div *ngIf="f.TermsAndConditions?.errors?.required">
                                {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- <p *ngIf="!isReadOnly && !registerForm.invalid" class="form-group"> -->
            <p *ngIf="(formMode==FormMode.Add && user.RegisterTypeId==RegisterType.PortalUser )||
                      (formMode==FormMode.Add &&user.RegisterTypeId==RegisterType.Agent && validateSubmitButton) ||
                      (formMode==FormMode.Add && user.RegisterTypeId==RegisterType.Supplier && isLocalSupplier && isSupplierFormValid)"
                class="btns-holder">
                <button class="btn btn-primary SCAcustomBtn">
                    {{ 'FRONT_USER.REGISTRATION_FORM.REGISTER' | translate}}
                </button>
                <!--<img *ngIf="loading" class="pl-3"
                     src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />-->
                <!-- <button type="button" (click)="cancel()"  class="btn btn-link SCAcustomBtn">{{ 'FRONT_USER.CANCEL' | translate}}</button> -->
                <button type="button" Confirmation (confirmationClick)="cancel()" class="btn btn-link SCAcustomBtn">
                    {{ 'FRONT_USER.CANCEL' | translate}}
                </button>
            </p>
            <p *ngIf="formMode == FormMode.Edit &&
                      (user.RegisterTypeId==RegisterType.Agent && isTabOneValid && isTabTwoValid)" class="btns-holder">
                <button class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SUBMIT' | translate}}</button>
                <!--<img *ngIf="loading" class="pl-3"
                    src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />-->
                <!-- <button type="button" (click)="cancel()"  class="btn btn-link SCAcustomBtn">{{ 'FRONT_USER.CANCEL' | translate}}</button> -->
            </p>
        </form>

    </div>

    <!-- Confirmation -->
    <div *ngIf="showRequest" class="alert alert-success" role="alert">
        <div class="alignC">
            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g>
                    <g>
                        <path
                            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
                        </path>
                    </g>
                </g>
            </svg>
            <p *ngIf="!showAgentMsg && !showSupplierMsg">{{ 'FRONT_USER.SUCCESS_MESSAGE' | translate }}</p>
            <p *ngIf="showAgentMsg">{{ 'FRONT_USER.SUCCESS_AGENT_MESSAGE' | translate }}</p>
            <p *ngIf="showSupplierMsg">{{ 'FRONT_USER.SUCCESS_SUPPLIER_MESSAGE' | translate }}</p>
            <p *ngIf="formMode==FormMode.Add">{{ 'FRONT_USER.GOBACK' | translate }} <a (click)="goToHome()">
                    {{ 'FRONT_USER.WORKSPACE.HOME' | translate }}</a></p>
            <p *ngIf="formMode==FormMode.Edit">{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
                    {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
        </div>
    </div>


    <div *ngIf="requestId">
        <app-messaging [RegestRequestId]="requestId"></app-messaging>
    </div>
